export function invoiceRelances(bill) {
  const items = Array.isArray(bill?.relance) ? bill.relance : [];
  return items
    .map((item, index) => {
      if (!item || typeof item !== "object") return null;
      const parsed = item.date ? new Date(item.date) : null;
      const date = parsed && !Number.isNaN(parsed.getTime()) ? parsed.toISOString() : null;
      const message = typeof item.message === "string" ? item.message.trim() : "";
      const contactEmail = typeof item.contactEmail === "string" ? item.contactEmail.trim() : "";
      return {
        id: `${date || "sans-date"}-${contactEmail || "contact"}-${index}`,
        message: message || "Relance",
        contactEmail,
        date,
      };
    })
    .filter(Boolean)
    .sort((left, right) => {
      if (!left.date && !right.date) return 0;
      if (!left.date) return 1;
      if (!right.date) return -1;
      return new Date(right.date) - new Date(left.date);
    });
}

export function formatRelanceDate(value) {
  if (!value) return "Date inconnue";
  const parts = new Intl.DateTimeFormat("fr-FR", {
    timeZone: "Europe/Paris",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date(value));
  const part = (type) => parts.find((item) => item.type === type)?.value || "";
  return `${part("day")}/${part("month")}/${part("year")} ${part("hour")}:${part("minute")}`;
}
